import React from 'react';
import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { CustomHeader } from '@shared/components/md-design-system/Layout/CustomHeader';
import { ChatChannelListSkeleton } from './ChatChannelListSkeleton';
import { ChatThreadSkeleton } from './ChatThreadSkeleton';
import { CustomChatHeader } from '../CustomChatHeader';

export const ChatListHeader = () => {
    const { t } = useTranslation();
    return <CustomHeader className="px-8" title={t('screens.chat.title')} />;
};

export const ChatListConnecting = () => (
    <View className="flex-1 bg-white">
        <ChatListHeader />
        <ChatChannelListSkeleton />
    </View>
);

export const ChatThreadConnecting = () => {
    const { params } = useRoute<any>();
    return (
        <View className="flex-1 bg-white">
            <CustomChatHeader channel={null} fallbackTitle={params?.channelName} />
            <ChatThreadSkeleton />
        </View>
    );
};
